var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgForgeDarkIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723",
    transform: "translate(-2221.882 -3512.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1919",
    "data-name": "Path 1919",
    d: "M2238.175,3521.345l1.125-2.562,1.212.372.465,2.787-2.019,4.327-2.493-1.12.9-2.231-8.885-3.452.988-2.15Z",
    transform: "translate(-5.805 -3.984)",
    fill: "var(--photon-product-primary)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1920",
    "data-name": "Path 1920",
    d: "M2230.971,3606.079l10.806-.214v.946s-3.98,1.221-4.689,2.779,1.855,3.453,1.855,3.453l.155,1.513h-2.2a9.085,9.085,0,0,0-4.99,0,2.107,2.107,0,0,1-1.3,0h-1.011v-1.513s3.14-1.654,1.875-3.313c-.5-.651-2.609-.41-3.876-.949a8.229,8.229,0,0,1-3.057-2.376Z",
    transform: "translate(-2.332 -82.117)",
    fill: "var(--photon-product-secondary)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1918",
    "data-name": "Path 1918",
    d: "M14.448,21.952a.383.383,0,0,1-.151-.031l-2.525-1.1h0a.389.389,0,0,1-.221-.211.347.347,0,0,1,.008-.279l.906-1.987L3.8,14.949a.366.366,0,0,1-.2-.2.354.354,0,0,1,0-.278L4.64,12.193a.349.349,0,0,1,.291-.211l.042,0a.463.463,0,0,1,.174.035l8.366,4.028,1.094-2.4a.373.373,0,0,1,.3-.213l.038,0a.384.384,0,0,1,.152.032l1.107.481a.364.364,0,0,1,.217.283l.407,2.9a.358.358,0,0,1-.029.2l-2.014,4.415a.372.372,0,0,1-.3.214Zm.688-7.679L12.388,20.3l1.872.813,1.807-3.961.013-.027-.365-2.6-.578-.251Zm-9.975-1.44h0l-.726,1.591,8.33,3.257.444-.973L5.161,12.833Z",
    transform: "translate(2218.698 3500.82)",
    fill: "var(--photon-product-primary)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1915",
    "data-name": "Path 1915",
    d: "M6.232,353.769H.871a7.09,7.09,0,0,0,2.353,1.583,9.37,9.37,0,0,0,3.008.763Zm.011,3.037a10.107,10.107,0,0,1-3.307-.826,7.532,7.532,0,0,1-2.785-1.972.645.645,0,0,1-.142-.292.515.515,0,0,1,.047-.336.532.532,0,0,1,.269-.246.777.777,0,0,1,.342-.056H6.232v-.1a.35.35,0,0,1,.354-.345H17.646a.35.35,0,0,1,.354.345v1.013a.348.348,0,0,1-.3.341,11.409,11.409,0,0,0-3.386,1.288,2.226,2.226,0,0,0-1.176,1.529,1.345,1.345,0,0,0,.155.8,3.635,3.635,0,0,0,.522.714c.333.373.793.815,1.394,1.381a.341.341,0,0,1,.127.265v1.369a.35.35,0,0,1-.354.345H12.727a.359.359,0,0,1-.169-.042,5.283,5.283,0,0,0-1.088-.326,7.1,7.1,0,0,0-2.546,0,5.282,5.282,0,0,0-1.086.326.359.359,0,0,1-.17.043H5.41a.35.35,0,0,1-.354-.345V360.3a.341.341,0,0,1,.127-.265c.133-.125.269-.246.413-.374a5.02,5.02,0,0,0,1.59-1.916,1.076,1.076,0,0,0,.03-.255.641.641,0,0,0-.066-.309.213.213,0,0,0-.137-.108.377.377,0,0,0-.083-.007H6.586a.352.352,0,0,1-.343-.259m5.362,4.163a6.2,6.2,0,0,1,.768.2v-.684a8.907,8.907,0,0,0-1.2-.687,2.133,2.133,0,0,0-1.957,0,8.916,8.916,0,0,0-1.2.687v.684a6.189,6.189,0,0,1,.767-.2,7.787,7.787,0,0,1,2.816,0m-4.045-1.015a9.876,9.876,0,0,1,1.365-.785,2.835,2.835,0,0,1,2.543,0,9.874,9.874,0,0,1,1.365.785h1.283c-.293-.283-.543-.534-.754-.764a4.48,4.48,0,0,1-.725-.989,1.958,1.958,0,0,1-.2-1.128,2.861,2.861,0,0,1,1.491-2.033,11.663,11.663,0,0,1,3.363-1.322v-.4H6.939v3.055a1.079,1.079,0,0,1,.237.029.894.894,0,0,1,.59.443,1.307,1.307,0,0,1,.157.644,1.751,1.751,0,0,1-.052.414,4.751,4.751,0,0,1-1.559,2.051Zm5.52,1.37h1.551v-.679H13.08Zm-7.317,0H7.314v-.679H5.763Z",
    transform: "translate(2221.882 3170.784)",
    fill: "var(--photon-product-secondary)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1921",
    "data-name": "Path 1921",
    d: "M.277,0A.287.287,0,0,1,.558.286L.593,5.128a.277.277,0,0,1-.277.283.287.287,0,0,1-.282-.287L0,.282A.277.277,0,0,1,.277,0Z",
    transform: "translate(2225.501 3521.37) rotate(-71.52)",
    fill: "var(--photon-product-detail)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1922",
    "data-name": "Path 1922",
    d: "M.332,0A.277.277,0,0,1,.61.284L.575,5.125a.287.287,0,0,1-.282.287.277.277,0,0,1-.277-.283L.051.288A.287.287,0,0,1,.332,0Z",
    transform: "translate(2234.315 3523.336) rotate(-108.48)",
    fill: "var(--photon-product-detail)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1923",
    "data-name": "Path 1923",
    d: "M.28,0,4.528.042a.29.29,0,0,1,.287.284A.276.276,0,0,1,4.534.6L.286.56A.29.29,0,0,1,0,.277.276.276,0,0,1,.28,0Z",
    transform: "matrix(0.875, -0.485, 0.485, 0.875, 2234.839, 3521.353)",
    fill: "var(--photon-product-detail)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1924",
    "data-name": "Path 1924",
    d: "M.289.035,2.6.011a.276.276,0,0,1,.281.278.29.29,0,0,1-.287.284L.283.6A.276.276,0,0,1,0,.318.29.29,0,0,1,.289.035Z",
    transform: "translate(2229.458 3521.522) rotate(-151)",
    fill: "var(--photon-product-detail)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgForgeDarkIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/forge_dark_icon.4a1e1b62647e6f18f896cbd6f178e99d.svg";